export default __webpack_public_path__ + "static/media/wall-opening-main-category.45b35688.jpeg";